exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget{border:1px solid #494949;height:100%;overflow-y:auto}.widget.border-error{border-color:#ff1744}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/style/widget.css
// module id = 290
// module chunks = 0